import React, { FC } from 'react';
import { PaperStyled } from './style';

interface PaperProps {
  border?: boolean;
  maxWidth?: number;
  height?: number;
  as?: any;
  className?: any;
}

const Pagination: FC<PaperProps> = ({
  as,
  border,
  maxWidth,
  height,
  children,
  className,
}) => {
  return (
    <PaperStyled
      className={className}
      border={border}
      maxWidth={maxWidth}
      height={height}
      as={as}
    >
      {children}
    </PaperStyled>
  );
};

export default Pagination;
